import PropTypes from 'prop-types'

import { Paper, Typography } from '@mui/material'

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align='center' variant='subtitle1'>
        داده ای وجود ندارد
      </Typography>
    </Paper>
  )
}

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
}
